import { useEffect, useState } from 'react';
import { LitNodeClient } from '@lit-protocol/lit-node-client';
import { LitAuthClient } from '@lit-protocol/lit-auth-client';
import { ProviderType } from '@lit-protocol/constants';
export default function useLitClients({
  redirectUri
}) {
  const [litNetwork, setLitNetwork] = useState(process.env.NEXT_PUBLIC_LIT_NETWORK);
  const [litAuthClients, setLitAuthClients] = useState(null);
  const [litNodeClient, setLitNodeClient] = useState(null);
  const [clientCreated, setClientCreated] = useState(false);
  const [clientCreationError, setClientCreationError] = useState(null);
  const [clientsLoading, setClientsLoading] = useState(false);
  async function initClients() {
    try {
      setClientsLoading(true);
      // Set up LitNodeClient and connect to Lit nodes
      const litNodeClient = new LitNodeClient({
        litNetwork,
        debug: true,
        rpcUrl: process.env.NEXT_PUBLIC_LIT_RPC_URL
      });
      await litNodeClient.connect();
      setLitNodeClient(litNodeClient);
      const authClientNames = [ProviderType.Google, ProviderType.EthWallet, ProviderType.Apple];
      const authClients = authClientNames.reduce((acc, name) => {
        const client = new LitAuthClient({
          litNodeClient,
          rpcUrl: process.env.NEXT_PUBLIC_LIT_RPC_URL,
          litRelayConfig: {
            //since it's only used in spot, keeping it hardcoded
            relayApiKey: '15f362f6-a0cd-4f27-a02c-07311831389a_brihu'
          }
        });
        const provider = client.initProvider(name);
        if (name !== ProviderType.EthWallet) {
          provider.redirectUri = redirectUri;
        }
        return Object.assign(Object.assign({}, acc), {
          [name]: {
            client,
            provider
          }
        });
      }, {});
      setLitAuthClients(authClients);
      setClientCreated(true);
    } catch (e) {
      console.error('Error initializing Lit clients:', e);
      setClientCreationError(`Error initializing Lit clients: ${e.message}`);
    } finally {
      setClientsLoading(false);
    }
  }
  useEffect(() => {
    setLitAuthClients(null);
    setLitNodeClient(null);
    initClients();
  }, [litNetwork]);
  return {
    litNetwork,
    setLitNetwork,
    clients: {
      litAuthClients,
      litNodeClient,
      clientCreated,
      clientCreationError,
      clientsLoading
    }
  };
}